import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  urlRedCore:string = environment.url_login;
  urlMotorCustom: string = '';
  urlMotor:string = this.urlMotorCustom + '/public_servicios/login.php';
  constructor(private http:HttpClient, private generalService: GeneralService, private router:Router ) {     
  }
  loginServiceCore(username:any,password:any){
    let data = {
      username,
      password
    }
   return this.http.post(`${this.urlRedCore}/cognito/token`, data, { headers: { skip: 'true' }})
  }
  loginServiceMotor(username:any, password:any, urlMotor:string){
    this.urlMotorCustom = urlMotor;
    console.log(this.urlMotorCustom);
    
    localStorage.setItem('urlMotor', this.urlMotorCustom);
    this.urlMotor = this.urlMotorCustom + '/usuarios/login';

    let data = {
      usuario: username,
      password: password,
    op: 1,
    }
    console.log(this.urlMotor);
    
    return this.http.post(`${this.urlMotor}`,data)
  }

  signIn(data: any, tokenCaptcha: string) {

    const urlMotor = data.urlMotor + '/ejecucionmotor/login';
    localStorage.setItem('urlMotor', data.urlMotor);

  let datosMotor = {
    op: 1,
    referencia: null,
    datos_front: {
        username: data.usuario,
        password: data.password
    },
    token: null
  }

  return this.http.post<{ 
    datos: { 
      resp_motor: { 
        datos: { 
          informacion_general: {
            token_id: string
            token_actualizacion: string
            usuario: string
            ruta: string
            AccessToken: string
            RefreshToken: string
            IdToken: string
            tokenIdMotor: string
            tokenActualizacionMotor: string
            tokenIdCliente: string
            tokenAccesoCliente: string
            tokenActualizacionCliente: string
          }[] 
        } 
      },
      desenlace_contenido: {
        resultado: 0 | 1
      },
      mensaje: string
    },
    error: 1 | 0
  }>(`${urlMotor}`, datosMotor)
  


    //try {

      /*
      if (response.error == 0) {

        if (response.datos.desenlace_contenido.resultado != 0) {
          localStorage.setItem('Token-Motor', encodeURIComponent(response.datos.resp_motor.datos.informacion_general[0].tokenIdMotor))
          localStorage.setItem('token', response.datos.resp_motor.datos.informacion_general[0].tokenIdMotor);
          localStorage.setItem('Token-Actualizacion', response.datos.resp_motor.datos.informacion_general[0].tokenActualizacionMotor);
          localStorage.setItem('Id-Token-Cognito', encodeURIComponent(response.datos.resp_motor.datos.informacion_general[0].tokenIdCliente))
          localStorage.setItem('Refresh-Token-Cognito', encodeURIComponent(response.datos.resp_motor.datos.informacion_general[0].tokenActualizacionCliente))
          localStorage.setItem('Access-Token-Cognito', encodeURIComponent(response.datos.resp_motor.datos.informacion_general[0].tokenAccesoCliente))
          this.router.navigate([response.datos.resp_motor.datos.informacion_general[0].ruta]);
        } else {
          this.globalService.cargandoCoomeva(false);
          this.modalService.closeAll();

          this.globalService.showMessage({
            message: response.datos.mensaje,
            icon: 'fal fa-exclamation',
            button: 'ENTENDIDO',
            callback: () => { },
          });
        }

      } else {
        this.globalService.cargandoCoomeva(false);
        this.modalService.closeAll();

        this.globalService.showMessage({
          message: 'No pudimos validar tus datos.',
          icon: 'fal fa-exclamation',
          button: 'ENTENDIDO',
          callback: () => { },
        });
      }*/
    //} catch (error: any) {
      //this.globalService.cargandoCoomeva(false);
      // this.modalService.closeAll();

      /*
      if (error.error.error == 1) {
        this.globalService.showMessage({
          message: error.error.mensaje,
          icon: 'fal fa-exclamation',
          button: 'ENTENDIDO',
          callback: () => { },
        });
      } else {

        if (error.error.datos.desenlace_contenido.resultado == 1) {
          localStorage.setItem('Token-Motor', encodeURIComponent(error.error.datos.resp_motor.datos.informacion_general[0].tokenIdMotor))
          localStorage.setItem('token', error.error.datos.resp_motor.datos.informacion_general[0].tokenIdMotor);
          localStorage.setItem('Token-Actualizacion', error.error.datos.resp_motor.datos.informacion_general[0].tokenActualizacionMotor);
          localStorage.setItem('Id-Token-Cognito', encodeURIComponent(error.error.datos.resp_motor.datos.informacion_general[0].tokenIdCliente))
          localStorage.setItem('Refresh-Token-Cognito', encodeURIComponent(error.error.datos.resp_motor.datos.informacion_general[0].tokenActualizacionCliente))
          localStorage.setItem('Access-Token-Cognito', encodeURIComponent(error.error.datos.resp_motor.datos.informacion_general[0].tokenAccesoCliente))
          this.router.navigate([error.error.datos.resp_motor.datos.informacion_general[0].ruta]);

        } else if (error.error.datos.desenlace_contenido.resultado == 0) {
          this.globalService.showMessage({
            message: error.error.datos.mensaje,
            icon: 'fal fa-exclamation',
            button: 'ENTENDIDO',
            callback: () => { },
          });
        } else {
          this.globalService.showMessage({
            message: error.error.datos.mensaje,
            icon: 'fal fa-exclamation',
            button: 'ENTENDIDO',
            callback: () => { },
          });
        }
      }*/
    //}


  }  

  refreshToken() {
		return this.http.post(
      `${environment.url_login}/cognito/refresh`,
			{refresh_token: localStorage.getItem('Refresh-Token-Cognito') }, { headers: { skip: 'true', isRefresh: 'true' } } 
		).pipe(
			tap((response: any) => {
        this.saveToken('Id-Token-Cognito', response.data.IdToken);
			}),
			catchError((error) => {
				return throwError( ()=> error);
			})
		);
	}

  saveToken(key:string, token: string) {
    localStorage.removeItem(key);
    localStorage.setItem(key, token);
  }
}
